import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(2),
  },
  selectRecipient: {
    fontSize: '16px',
    lineHeight: theme.spacing(3),
    color: theme.palette.labraText.primary,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  sectionText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    paddingTop: theme.spacing(3),
  },

  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 1, 0, 0),
  },
}))
